import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoElement from '../../components/InfoElement';
import { Header1 } from '../../components/ViewWrapper';
import logo from '../../img/Airthings_Favicon.png';
import { Invite } from '../../models/commonModels';
import styles from '../registerUser/RegisterView.module.scss';

type Props = {
    invite: Invite;
    userRegistered: boolean;
    ssoUser?: boolean;
};

const InviteInfo = ({ invite, userRegistered, ssoUser = false }: Props): JSX.Element => {
    const { t: txt } = useTranslation();
    const { email, name, userGroupName } = invite;
    return (
        <>
            <img src={logo} className={styles.logo} alt={txt('Logo.AirthingsLogo')} />
            <Header1>{txt('Invite.WelcomeUser', { name })}</Header1>
            {ssoUser && <Header1>{txt('SingleSignOn.SsoSignIn')}</Header1>}
            <InfoElement
                iconName="error_outline"
                infoText={txt(userRegistered ? 'Invite.SignInToAcceptInvite' : 'Invite.RegisterToAcceptInvite', {
                    email,
                    userGroupName,
                })}
                testAttr={'invite-info'}
            />
        </>
    );
};

export default InviteInfo;
